import { FaGithub, FaLinkedin, FaTwitter } from "react-icons/fa";

export const NAME = "Pratik Chawla";
export const EMAIL = "pratik.chawla42@gmail.com";
export const PHONE = "(765) 637-6628";
export const CALENDLY = "https://calendly.com/pratik-chawla/30min";
export const RESUME =
  "https://drive.google.com/file/d/1KTZeEYISOMhopeDiQwa8H_q-8-tqjvoZ/view?usp=drive_link";

export const SOCIALS = [
  { label: "GitHub", href: "https://github.com/pratsc7117", icon: FaGithub, handle: "pratsc7117" },
  { label: "LinkedIn", href: "https://linkedin.com/in/pratik-chawla", icon: FaLinkedin, handle: "pratik-chawla" },
  { label: "Twitter", href: "https://twitter.com/patialaprats", icon: FaTwitter, handle: "@patialaprats" },
];

export const NAV = [
  { label: "Journal", to: "/journal" },
  { label: "Fitness", to: "/fitness" },
  { label: "Work", to: "/work" },
  { label: "About", to: "/about" },
];
